module.exports = __webpack_public_path__ + "static/media/icon_REPSEproveedor[1506].0d69cbaa.svg";